import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { MirrorsListItem } from '@modules/mirrors-list/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { MIRRORS_LIST_PERMISSIONS } from '@modules/mirrors-list/constants';
import {
  MIRRORS_LIST_EDIT_API_URL,
  MIRRORS_LIST_EDIT_QUERY_KEY,
} from '@modules/mirrors-list/submodules/edit/constants';

export default function useMirrorsListEditQuery(mirrorId: Ref<number | undefined>):
IContextQueryResult<MirrorsListItem, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [MIRRORS_LIST_EDIT_QUERY_KEY, mirrorId],
    queryFn: () => fetchGet<MirrorsListItem>(
      MIRRORS_LIST_EDIT_API_URL,
      {
        permission: MIRRORS_LIST_PERMISSIONS.SHOW,
        urlParams: {
          id: mirrorId.value,
        },
      },
    ),
    enabled: computed(() => !!mirrorId.value),
  });
}
